import api from "./api";

export const getLanes = () => api.get("/personal-kanban/lanes").then(r => r.data);
export const getStatuses = () => api.get("/personal-kanban/statuses").then(r => r.data);
export const getTable = () => api.get("/personal-kanban/table").then(r => r.data);
export const createLane = (data) => api.post("/personal-kanban/lanes", data).then(r => r.data);
export const updateLane = (id, data) => api.put(`/personal-kanban/lanes/${id}`, data).then(r => r.data);
export const deleteLane = (id) => api.delete(`/personal-kanban/lanes/${id}`);
export const reorderLanes = (lanes) => api.post("/personal-kanban/lanes/reorder", { lanes }).then(r => r.data);

export const createItem = (data) => api.post("/personal-kanban/items", data).then(r => r.data);
export const showItem = (id) => api.get(`/personal-kanban/items/${id}`).then(r => r.data);
export const updateItem = (id, data) => api.put(`/personal-kanban/items/${id}`, data).then(r => r.data);
export const deleteItem = (id) => api.delete(`/personal-kanban/items/${id}`);
export const reorderItems = (items) => api.post("/personal-kanban/items/reorder", { items }).then(r => r.data);

export const listTags = () => api.get("/tags").then(r => r.data);
export const listUsers = () => api.get("/users").then(r => {
  const d = r.data;
  if (Array.isArray(d)) return d;
  return Array.isArray(d?.users) ? d.users : [];
});
